import { render, staticRenderFns } from "./ProjectAssetTileManageReviewsAction.vue?vue&type=template&id=b17b6546"
import script from "./ProjectAssetTileManageReviewsAction.vue?vue&type=script&lang=js"
export * from "./ProjectAssetTileManageReviewsAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports